import React from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';

import img1 from '../img/banner.jpg';
import img2 from '../img/hema.jpg';
import img3 from '../img/pathology.jpg';


// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);



const Slider =()=> {
    let data= [
        {
            id: 1,
            imgSrc: img1,
        },
        {
            id: 2,
            imgSrc: img2,
        },
        {
            id: 3,
            imgSrc: img3,
        }

    ]
    return (
        <div className="slider" style={{"marginTop":"1rem"}}>
                
        <Swiper
            spaceBetween={0}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log('slide change')}
            loop={true}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false
            }}
            style={{
                "width": '100%',
                "height": '400px',
                "marginTop": '1rem !important',
                
            }}
        >
            {data.map((item, index)=>{
                return(
                    <SwiperSlide key={index}>
                        <img src={item.imgSrc} alt="slider" style={{ width: '100%' }} />
                    </SwiperSlide>
                )
            })}
        
            
        </Swiper>
        
       </div>
    )
}
export default Slider;